// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3o-OE","overflowing":"ReadFullNote_overflowing__2wfxY"};